import i18n from 'i18next';

import getRequiredLegendSchema from './getRequiredLegendSchema';

const sharedProps = {
  maxLength: 500,
  validators: [{ type: 'isNotEmptyString' }, { type: 'isRequired' }],
};

export default (model, hasUrlTextInput) => ({
  subject: { type: 'Text', label: i18n.t('subject'), ...sharedProps },
  ...(hasUrlTextInput && {
    url: { type: 'Text', label: i18n.t('url') },
  }),
  message: { type: 'TextArea', label: i18n.t('message'), ...sharedProps },
  character_limit: {
    type: 'CharacterLimit',
    isDecoration: true,
    limit: sharedProps.maxLength - (model.message?.length ?? 0),
    prefix: i18n.t('character-limit-prefix'),
  },
  ...getRequiredLegendSchema(),
});
